module.exports = __webpack_public_path__ + "img/caiji.2c093252.png";